import { FAQAccordion, type FAQAccordionItem } from "@/components/FAQAccordion"

type FAQBlockData = {
  heading?: string
  subheading?: string
  items?: FAQAccordionItem[]
}

export function FAQBlockSection({ data }: { data: FAQBlockData }) {
  return (
    <FAQAccordion
      heading={data.heading}
      subheading={data.subheading}
      items={data.items ?? []}
      className="border-t border-[var(--border)]/80 bg-gradient-to-b from-[var(--section-alt)]/50 to-[var(--background)]"
    />
  )
}
